
import { mapMutations, mapState, mapGetters } from "vuex";
export default{
  data(){
    return{

    }
  },
  computed: {
    ...mapGetters('audio', {
      PlayingMusic: "getCurAudio",
    })
  },
  
}